angular.module('gym.calendar').directive('editTypeSelector', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/edit_type_selector.html.slim'),
    scope: {
      event: '='
    },
    controller: ["$scope", function($scope) {
      $scope.event.edit_type = $scope.event.edit_type || 'single';
      $scope.selectType = function(type) {
        return $scope.event.edit_type = type;
      };
      return $scope.isRepeating = function() {
        return !!$scope.event.repeats || !!$scope.event.repeat_until_date || !!$scope.event.infinite;
      };
    }]
  };
});
